
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import LoginButton from '@/account/components/LoginButton.vue';

export default defineComponent({
  name: 'Registration',
  mixins: [Form],
  components: {
    LoginButton,
  },
  data() {
    return {};
  },
});
